<script>
import EssaySummarizeForm from "@/components/essay_summarize_form.vue";
import { freeToolAiSummary } from "@/api/requests/freeTools";

export default {
  name: "SummarizeEssayView",

  components: { EssaySummarizeForm },

  props: {
    requestType: {
      type: String,
      default: "normal-view", // or free-tools
    },
  },

  data() {
    return {
      loading: false,
      error: "",
      summarizedEssay: null,
    };
  },

  methods: {
    async summarizeEssay(payload) {
      try {
        this.loading = true;

        const {
          data: { content },
        } = await freeToolAiSummary(payload);

        this.summarizedEssay = content;

        this.error = "";
      } catch (error) {
        this.error = error.response?.data?.error;
      } finally {
        this.loading = false;
      }
    },

    printEssaySummary() {
      window.print();
    },
  },
};
</script>

<template>
  <eg-b-container>
    <div
      v-if="requestType === 'normal-view' && !summarizedEssay && !loading"
      class="text-right svg-container"
    >
      <img src="../assets/illustrations/summarize-illustration.svg" alt="" />
    </div>
    <section>
      <eg-b-row v-if="loading">
        <eg-b-col md="3"></eg-b-col>
        <eg-b-col md="6" class="text-center">
          <eg-b-spinner
            class="mb-4"
            style="width: 3rem; height: 3rem"
          ></eg-b-spinner>

          <h4>{{ $t("essays.summarizingEssay") }}</h4>
        </eg-b-col>
        <eg-b-col md="3"></eg-b-col>
      </eg-b-row>
      <eg-b-row v-else>
        <eg-b-col cols="12">
          <eg-b-alert v-if="error" variant="danger" show>{{
            error
          }}</eg-b-alert>

          <template v-if="!summarizedEssay">
            <h1 class="mb-4">{{ $t("essays.summarize") }}</h1>
          </template>
        </eg-b-col>
        <eg-b-col>
          <div v-if="!summarizedEssay">
            <p class="mb-2">
              {{ $t("freeTools.summarize.uploadToSummarize") }}
            </p>
            <essay-summarize-form @essaySubmitted="summarizeEssay" />
          </div>

          <div v-else>
            <div class="d-flex justify-content-between mb-3">
              <h1>{{ $t("freeTools.summarize.essaySummary") }}</h1>
              <eg-b-button class="no-print" @click="printEssaySummary">
                {{ $t("freeTools.summarize.printSummary") }}
              </eg-b-button>
            </div>

            <div id="essay-summary" v-html="summarizedEssay"></div>
          </div>
        </eg-b-col>
        <eg-b-col v-if="!summarizedEssay" cols="1"></eg-b-col>
        <eg-b-col v-if="!summarizedEssay" cols="6">
          <div class="help-box">
            <p class="font-rubik">
              {{ $t("freeTools.summarize.howDoesItWork") }}
            </p>
            <ul>
              <li>{{ $t("freeTools.summarize.howItem1") }}</li>
              <li>{{ $t("freeTools.summarize.howItem2") }}</li>
            </ul>
          </div>
        </eg-b-col>
      </eg-b-row>
    </section>
  </eg-b-container>
</template>
<style scoped lang="scss">
#essay-summary::v-deep {
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
  }

  /* Table border and spacing */
  #container table,
  th,
  td {
    border: 1px solid lavender;
  }

  /* Header styles */
  th {
    background-color: lavender;
    color: #4b0082; /* Indigo for contrast */
    padding: 10px;
    text-align: left;
  }

  /* Row styles */
  td {
    padding: 10px;
    background-color: #e6e6fa; /* Light lavender for rows */
    color: #333; /* Darker text color for readability */
  }

  /* Alternate row styling (zebra stripes) */
  tr:nth-child(even) {
    background-color: #f0f0f8;
  }

  /* Hover effect */
  tr:hover {
    background-color: #d8bfd8; /* Thistle color on hover */
    transition: background-color 0.3s ease;
  }

  /* Table caption */
  caption {
    font-size: 1.5em;
    margin-bottom: 10px;
    color: #4b0082;
    font-weight: bold;
  }
}
</style>
